import { useTranslation } from 'react-i18next'
import type { Field } from '@pbt/pbt-ui-components'

import { KibPreloadedUserSelect } from '~/components/common/inputs/user-select/KibPreloadedUserSelect'
import { KibSystemUserSelect } from '~/components/common/inputs/user-select/KibSystemUserSelect'
import { UserSelectFilterScope } from '~/components/common/inputs/UserSelect'

interface KibChatAssigneeSelectProps {
  assigneeField: Field
  isContextItem: boolean
  isSystemMessage: boolean
  onAssigneeChange: (value: string) => void
}

const KibChatAssigneeSelect = ({
  isSystemMessage,
  isContextItem,
  assigneeField,
  onAssigneeChange,
}: KibChatAssigneeSelectProps) => {
  const { t } = useTranslation('Common')

  if (isSystemMessage) {
    return <KibSystemUserSelect />
  }

  return (
    <KibPreloadedUserSelect
      reset
      filterScope={UserSelectFilterScope.Staff}
      label={assigneeField.label}
      placeHolder={assigneeField.value ? '' : t('Common:UNASSIGNED')}
      readOnly={!isContextItem}
      userSelectStateId="chat-container-assignee"
      value={assigneeField.value ?? ''}
      onChange={onAssigneeChange}
    />
  )
}

export default KibChatAssigneeSelect
